var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.876,
    height: 34.876,
    viewBox: "0 0 34.876 34.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5792",
    "data-name": "Group 5792",
    transform: "translate(9329.732 -9257.498)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_580",
    "data-name": "Ellipse 580",
    cx: 17.438,
    cy: 17.438,
    rx: 17.438,
    ry: 17.438,
    transform: "translate(-9329.732 9257.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5799",
    "data-name": "Group 5799",
    transform: "translate(-9322.765 9264.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M198.253,278.67h-9.4a5.777,5.777,0,0,0-5.774,5.774v9.4a5.777,5.777,0,0,0,5.774,5.774h9.4a5.777,5.777,0,0,0,5.775-5.774v-9.4A5.777,5.777,0,0,0,198.253,278.67Zm4.083,15.151a4.1,4.1,0,0,1-4.1,4.1h-9.355a4.1,4.1,0,0,1-4.1-4.1v-9.355a4.1,4.1,0,0,1,4.1-4.1h9.355a4.1,4.1,0,0,1,4.1,4.1v9.355Z",
    transform: "translate(-183.08 -278.67)",
    fill: "#b734b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M197.673,287.75a5.523,5.523,0,1,0,5.523,5.523A5.523,5.523,0,0,0,197.673,287.75Zm0,9.12a3.6,3.6,0,1,1,3.6-3.6A3.6,3.6,0,0,1,197.673,296.87Z",
    transform: "translate(-187.2 -282.794)",
    fill: "#b734b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M212.938,286.379a1.239,1.239,0,1,1-1.239-1.239A1.242,1.242,0,0,1,212.938,286.379Z",
    transform: "translate(-195.516 -281.609)",
    fill: "#b734b7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.d5beecb03bcaeee53c9bafbe9dfb5d24.svg";
export { ForwardRef as ReactComponent };